import {
    Dialog,
    DialogContent,
    Divider,
    Grid,
    Typography
} from '@mui/material';
import { CancelButtonGrey, CancelButtonWhite } from '@tassat/button';
import * as React from 'react';

import muiStyles from './styles';
import { FormModalProps } from './types';

export default function FormModal(props: FormModalProps) {
    const {
        open,
        title,
        Form,
        formProps,
        onClose,
        formType = 'regularForm'
    } = props;

    const classes = muiStyles(props);
    const isActionForm = formType === 'actionForm';

    return (
        <Dialog
            classes={{ paperWidthXl: classes.paperWidthXl }}
            disableEscapeKeyDown
            maxWidth='xl'
            onClose={(event, reason) => {
                if (reason === 'backdropClick') return;
                onClose();
            }}
            open={open}
            transitionDuration={{
                enter: 0,
                exit: 0
            }}
        >
            <Grid
                className={classes.root}
                container
                direction='column'
                spacing={0}
                wrap='nowrap'
            >
                {isActionForm ? (
                    <Grid
                        container
                        item
                        justifyContent='center'
                        spacing={0}
                        xs={12}
                    >
                        <Grid
                            alignItems='center'
                            className={classes.actionHeader}
                            container
                            direction='row'
                            item
                            justifyContent='center'
                            spacing={0}
                            wrap='nowrap'
                            xs={12}
                        >
                            {title && (
                                <Typography className={classes.actionHeaderTitle}>
                                    {title}
                                </Typography>
                            )}
                        </Grid>
                        <Grid
                            className={classes.actionCancelButton}
                            item
                        >
                            <CancelButtonWhite onClick={onClose} />
                        </Grid>
                    </Grid>
                ) : (
                    <Grid
                        className={classes.title}
                        container
                        item
                        justifyContent='center'
                        spacing={0}
                        xs={12}
                    >
                        <Grid
                            item
                            xs={11}
                        >
                            {title || 'Please Complete'}
                        </Grid>
                        <Grid
                            className={classes.cancelButton}
                            item
                            xs={1}
                        >
                            <CancelButtonGrey onClick={onClose} />
                        </Grid>
                    </Grid>
                )}
                <Divider variant='middle' />
                <Grid
                    item
                    xs={12}
                >
                    <DialogContent>
                        <Form
                            formProps={formProps}
                            onClose={onClose}
                        />
                    </DialogContent>
                </Grid>
            </Grid>
        </Dialog>
    );
}